/**
 * INNFLOW DESIGN SYSTEM V2.0 - useDebounce Hook
 * 
 * Hook para debounce de valores
 * 
 * @version 2.0.0
 * @author INNFLOW Design Team
 */

import { useEffect, useState } from 'react';

/**
 * useDebounce - Hook para debounce de valores
 * 
 * @param value - Valor a ser debounced
 * @param delay - Delay em milissegundos (padrão: 300ms)
 * @returns Valor debounced
 */
export const useDebounce = <T>(value: T, delay: number = 300): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
